export default __webpack_public_path__ + "static/media/Hot Chocolate - proportioned_170.8d5207f1.jpg";